/**
 * @description Axios HTTP Handler Utility
 * @author Fahid Mohammad
 */
import axios from 'axios'
import store from '../store'
import config from '../config'
import i18n from '../i18n';

let http = axios.create({
    baseURL: config.SANAR_SERVICES,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'sales-channel': 'MWEB',
        'lang': i18n.locale == 'en' ? '0' : '1' ,
        'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone||'Asia/Riyadh',
        'hybrid': true
    },
    withCredentials: false
})
http.interceptors.request.use((req) => {
    let token = store.getters['user/getToken'] || null
    req.headers['lang'] = store.getters['common/getLocale'] == 'en'  ? '0' : '1' ,
    req.headers['country'] = store.getters['common/getCountry'] || 'SA'
    if (token) {
        req.headers['Authorization'] = token;
    }
    return req;
}, (error) => {
    return Promise.reject(error)
})
http.interceptors.response.use(res => {
    let data = res.data
    if(res.data.status === 2000&&!res.config.url.includes('staticData')){
        // localStorage.removeItem('token')
        // store.dispatch('user/LOGOUT')
        // window.location.replace("/signin?expiry=expired")
        return data;
    }else{
        return data
    }
}, error => {
    if (error.response) {
        console.error('Response: ', error.response.data)
        console.error('Status: ', error.response.status)
        console.error('Headers: ', error.response.headers)
    } else {
        console.error('Error: ', error.message)
        // Error screen redirection need to hanndle 
        // window.location.replace("/i18n")
    }
    console.error('Config:', error.config)
    return Promise.reject(error)
})

export default http


// WEBPACK FOOTER //
// ./src/util/axios.js